import { Component, OnInit } from '@angular/core';
import { FileReaderEvent } from '../../GET_NEW_UI/setup-implement/setup-implement.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-additional-attachment',
  templateUrl: './add-additional-attachment.component.html',
  styleUrls: ['./add-additional-attachment.component.scss']
})
export class AddAdditionalAttachmentComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<AddAdditionalAttachmentComponent>) { }
  NewFileName: string = "";
  FilePreview: string = "";
 
  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close({data:this.FilePreview});
  }
  DialogClose_(){
    this.dialogRef.close();
  }
  onFileChangedUC(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.NewFileName = event.target.files[0].name
      // reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
      //   var fileUrl = (event.target.result);
      //   this.FilePreview = fileUrl;
      // }
      reader.onload = (event) => { // called once readAsDataURL is completed
        this.FilePreview = (<FileReader>event.target).result.toString();
    }
  }
  }
 
  
}
